/**
 * Detection of a Needle Engine runtime on the inspected page.
 *
 * The engine registers its version/generator on the page's global scope when its
 * module loads (needle-engine `engine_constants.ts`:
 * `globalThis["__NEEDLE_ENGINE_VERSION__"]`, `__NEEDLE_ENGINE_GENERATOR__`).
 * The extension shares the inspected page's JS context, so detection is a plain
 * property read — cheap enough to do at event time, which also catches engines
 * that finish loading after the editor started.
 */

export function getPageNeedleEngine(): { version: string; generator?: string } | null {
    const g = globalThis as { __NEEDLE_ENGINE_VERSION__?: unknown; __NEEDLE_ENGINE_GENERATOR__?: unknown };
    const version = g.__NEEDLE_ENGINE_VERSION__;
    if (typeof version !== "string") return null;
    const generator = g.__NEEDLE_ENGINE_GENERATOR__;
    return { version, generator: typeof generator === "string" ? generator : undefined };
}

/**
 * Telemetry props for a detected Needle Engine runtime — `{}` when none, so the
 * props are simply absent from the event. Spread into `logEvent` params:
 * `{ ...needleEngineTelemetryProps() }` → `needleEngine` (version string) and
 * `needleEngineGenerator` when the engine is present.
 */
export function needleEngineTelemetryProps(): { needleEngine?: string; needleEngineGenerator?: string } {
    const engine = getPageNeedleEngine();
    if (!engine) return {};
    return { needleEngine: engine.version, needleEngineGenerator: engine.generator };
}
